export default "__VITE_ASSET__CrimAO5N__"